import { BaseConverter } from "./base.converter";
import { ResponsePaginationTable } from "@models/response-pagination-table.model";
import { ResponsePaginationTableDto } from "@dtos/response-pagination-table.dto";
import { SortConverter } from "./sort.converter";
import { PlainAccomodationConverter } from "./plain-accomodation.converter";

export class ResponsePaginationTableConverter extends BaseConverter <ResponsePaginationTable, ResponsePaginationTableDto>{
    private accomodationConverter = new PlainAccomodationConverter()
    private sortConverter = new SortConverter()

    modelToDto(model: ResponsePaginationTable): ResponsePaginationTableDto {
        return new ResponsePaginationTableDto(
            model.content? this.accomodationConverter.modelsToDtos(model.content):undefined,
            model.pageable,
            model.last,
            model.totalElements,
            model.totalPages,
            model.size,
            model.number,
            model.sort? this.sortConverter.modelToDto(model.sort) : undefined,
            model.first,
            model.numberOfElements,
            model.empty
        )
    }
    dtoToModel(dto: ResponsePaginationTableDto): ResponsePaginationTable {
        return new ResponsePaginationTable(
            dto.content? this.accomodationConverter.dtosToModels(dto.content):undefined,
            dto.pageable,
            dto.last,
            dto.totalElements,
            dto.totalPages,
            dto.size,
            dto.number,
            dto.sort? this.sortConverter.dtoToModel(dto.sort) : undefined,
            dto.first,
            dto.numberOfElements,
            dto.empty
        )
    }

}